export default {
    install(Vue) {

        // moment 사용하지 않고 년.월.일 로 표기
        Vue.prototype.convertDateDotYMD = function(date) {
            let rtnDate = date || '';
            
            try {
                if(rtnDate.length > 10) {
                    rtnDate = rtnDate.substring(0, 10);
                }
                rtnDate = rtnDate.replace(/\-/gi, '.');
            }catch(excep) {
                console.error('convertDateDotYMD replace error param date : ', date);
                console.error('convertDateDotYMD exception message : ', excep);
            }
            
            return rtnDate;
        };
        
    }
}


// WEBPACK FOOTER //
// ./src/js/store/module/common/convertDateFormat.js